/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceAccountNativeDetailsBaseForSaas extends models.ServiceAccountNativeDetailsBase {
    constructor() {
        super();
        this.setDiscriminator("ServiceAccountNativeDetailsBaseForSaas");
    }

    getFixupPrototypeFunction() { return ServiceAccountNativeDetailsBaseForSaas.fixupPrototype; }

    static newInstance(model: Partial<ServiceAccountNativeDetailsBaseForSaas>): ServiceAccountNativeDetailsBaseForSaas {
        let obj = Object.assign(new ServiceAccountNativeDetailsBaseForSaas(), model);
        ServiceAccountNativeDetailsBaseForSaas.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceAccountNativeDetailsBaseForSaas>): ServiceAccountNativeDetailsBaseForSaas {
        if (!model) return null;
        return ServiceAccountNativeDetailsBaseForSaas.newInstance(<ServiceAccountNativeDetailsBaseForSaas> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceAccountNativeDetailsBaseForSaas) {
        if (!obj) return;

        models.ServiceAccountNativeDetailsBaseForSaas.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceAccountNativeDetailsBaseForSaas): boolean {
        if (models.ServiceAccountNativeDetailsBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ServiceAccountNativeDetailsBaseForSaas.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
